import { connectorClient } from '../utils/axios';

export const fetchGoogleRootFolders = async (connectionId, mimeType) => {
  try {
    const res = await connectorClient(connectionId).get(`gdrive/list/files?mimeType=${mimeType}`);
    return res.data.data;
  } catch (err) {
    const status = err.response?.status;
    const message =
      err.response?.data?.message ||
      err.response?.data?.error?.message ||
      "Failed to load data Google Drive";

    throw {
      status,
      message,
      raw: err,
    };
  }
};

/**
 * Get items inside a folder
 */
export const fetchGoogleFolderItems = async (connectionId, folderId, mimeType) => {
  if (!folderId) return [];
  const res = await connectorClient(connectionId).get(`/gdrive/list/folder/${folderId}?mimeType=${mimeType}`);
  return res.data.data; // items[]
};

export const fetchGoogleExtractSpreadsheet = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`/gdrive/sheets`, payload);
  return res.data;
};
